module.exports = __webpack_public_path__ + "static/media/failure_icn.be463b8b.svg";